import { gql } from "@apollo/client"

export const GET_MY_ORG_MEMBERS = gql`
  query getMyOrganizationMembers {
    myOrganization {
      id
      users {
        id
        firstName
        lastName
        email
        title
        profile {
          id
          imageUrl
        }
        organization {
          id
        }
      }
    }
  }
`
